import React from 'react';
import PropTypes from 'prop-types';
import { showWhenPermission } from '@/shared/components/security';
import RegistrationsPerReport from './RegistrationsPerReport';

const RegistrationsPerTaskTemplateContainer = ({ searchParams }) => (
  <RegistrationsPerReport
    externalParams={searchParams}
    reportType={6}
    reportKey="RegsPerTaskTemplateReport"
  />
);
RegistrationsPerTaskTemplateContainer.propTypes = {
  searchParams: PropTypes.shape({}),
};

RegistrationsPerTaskTemplateContainer.defaultProps = {
  searchParams: {},
};
export default showWhenPermission('RegistrationOwn', 'read')(RegistrationsPerTaskTemplateContainer);
